import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { getIcon } from "../lib/icons";
import { Plus, ArrowRight, Check } from "lucide-react";

// Robiquity-style expandable services list: one open at a time, opens inline.
export default function ServiceAccordion() {
  const { t, dir } = useLang();
  const [active, setActive] = useState(0);
  const flip = dir === "rtl" ? "scaleX(-1)" : "none";

  return (
    <div className="mt-12 border-t border-[rgba(10,31,60,0.12)]">
      {t.servicesList.map((s, i) => {
        const open = active === i;
        const Icon = getIcon(s.icon);
        return (
          <div key={s.slug} className="border-b border-[rgba(10,31,60,0.12)]">
            <button
              onClick={() => setActive(open ? -1 : i)}
              className="w-full flex items-center gap-5 py-6 md:py-8 text-start group"
            >
              <span className="font-display text-sm font-bold text-[color:var(--rq-green)] w-10 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span
                className="font-display text-2xl md:text-4xl font-bold tracking-tight flex-1 transition-colors duration-300"
                style={{ color: open ? "var(--rq-green)" : "var(--rq-navy)" }}
              >
                {s.title}
              </span>
              <span
                className="grid place-items-center h-11 w-11 rounded-full border shrink-0 transition-all duration-300"
                style={{
                  borderColor: open ? "var(--rq-green)" : "rgba(10,31,60,0.2)",
                  background: open ? "var(--rq-green)" : "transparent",
                  color: open ? "#fff" : "var(--rq-navy)",
                  transform: open ? "rotate(45deg)" : "rotate(0deg)",
                }}
              >
                <Plus size={20} />
              </span>
            </button>

            <div
              className="overflow-hidden transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
              style={{ maxHeight: open ? 460 : 0, opacity: open ? 1 : 0 }}
            >
              <div className="pb-8 grid md:grid-cols-3 gap-8 ltr:pl-14 rtl:pr-14">
                <div className="md:col-span-2">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="grid place-items-center h-12 w-12 rounded-xl bg-[rgba(14,122,58,0.1)] text-[color:var(--rq-green)]">
                      <Icon size={24} />
                    </span>
                  </div>
                  <p className="text-[15px] md:text-lg leading-relaxed text-[color:var(--rq-muted)]">{s.long}</p>
                  {s.slug === "cyber-security" ? (
                    <a href="https://cyberquess.com/" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 rq-glow-btn px-6 py-3 text-sm">
                      {t.servicesSection.cta}
                      <ArrowRight size={16} style={{ transform: flip }} />
                    </a>
                  ) : (
                    <Link to={`/services/${s.slug}`} className="mt-6 inline-flex items-center gap-2 rq-glow-btn px-6 py-3 text-sm">
                      {t.servicesSection.cta}
                      <ArrowRight size={16} style={{ transform: flip }} />
                    </Link>
                  )}
                </div>
                <div className="grid gap-3 content-start">
                  {s.features.map((f, k) => (
                    <div key={k} className="flex items-center gap-2.5 text-sm text-[color:var(--rq-navy)]">
                      <span className="grid place-items-center h-6 w-6 rounded-full bg-[rgba(14,122,58,0.12)] text-[color:var(--rq-green)] shrink-0">
                        <Check size={13} />
                      </span>
                      {f}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
